import { Navigate } from "react-router";

const PublicPage = () => {
  return <Navigate to={`/p/404`} replace />;
};

export default PublicPage;
